import { ExtractedAttribute } from '@common/types';
import { PromptResultFeatureType } from 'enums';
import { SuggestedValueProps } from 'hooks';
import { getValidMultipleDateSuggestion } from 'broker/utils';
import { buildSuggestedValueForArrayProps } from './suggestion-values-utils';

function formatToFullDate(monthYear: string): string {
  const [month, year] = monthYear.split('/');
  return `${month}/01/${year}`;
}

export function extractValidHireDateSuggestions(
  extractedAttribute: ExtractedAttribute<string[]>,
  promptResultFeature: PromptResultFeatureType,
): SuggestedValueProps | undefined {
  const formattedDates = extractedAttribute.value?.map((date) => formatToFullDate(date));
  const validSuggestion = getValidMultipleDateSuggestion({ ...extractedAttribute, value: formattedDates });

  if (validSuggestion) {
    return buildSuggestedValueForArrayProps(validSuggestion, promptResultFeature);
  }

  return undefined;
}
